import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import CommonDataTable from "../../../../common/DataTable";

const TransactionTab = ({
    summaryMetrics,
    columns,
    data,
    loading,
    totalRows,
    params,
    fetchData,
    customFilters,
    onExport,
    onRefresh,
    refreshLoading
}) => {
    return (
        <>
            <Row>
                {summaryMetrics.map((metric, index) => (
                    <Col md={3} key={index}>
                        <Card className={`card-animate bg-${metric.color}`}>
                            <CardBody>
                                <h5 className="text-white-50 fs-13">{metric.label}</h5>
                                <h4 className="text-white mb-0">
                                    {metric.value !== undefined && metric.value !== null ? metric.value : 0}
                                </h4>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>

            <CommonDataTable
                columns={columns}
                data={data || []}
                loading={loading}
                totalRows={totalRows || 0}
                filterParams={params}
                fetchData={fetchData}
                searchEnable={false}
                showAddButton={false}
                showRefreshButton={true}
                onRefresh={onRefresh}
                refreshLoading={refreshLoading}
                showExportButton={true}
                checkboxEnabled={true}
                exportFileName="so-transaction"
                excludeExportColumns={["__v", "isBreakEven", "isJokerRound", "jokerMultiplier", "jokerMultiplierApplied"]}
                customFilters={customFilters}
                onExport={onExport}
                cardcusclass="m-0"
                callcusclass="m-0"
            />
        </>
    );
};

export default TransactionTab;
